import React from 'react';
import PropTypes from 'prop-types';
import { ChevronRightIcon } from '@domain-group/fe-co-icon';
var illustration = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-listing-search-results/static/sold-illustration_99a52800.svg";
import * as styles from './view-sold-link.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesViewSoldLink = props => ___EmotionJSX("div", {
  css: styles.container
}, ___EmotionJSX("img", {
  css: styles.img,
  src: illustration,
  alt: ""
}), ___EmotionJSX("div", {
  css: styles.midbox
}, ___EmotionJSX("div", {
  css: styles.copy
}, ___EmotionJSX("span", {
  css: styles.title
}, props.titleText), ___EmotionJSX("span", {
  css: styles.detail
}, props.detailText)), ___EmotionJSX("div", {
  css: styles.linkMobile
}, ___EmotionJSX("button", {
  onClick: props.onClick,
  type: "button",
  css: styles.linkButton
}, "View all"), ___EmotionJSX(ChevronRightIcon, {
  css: styles.linkIcon
}))), ___EmotionJSX("div", {
  css: styles.linkDesktop
}, ___EmotionJSX("button", {
  onClick: props.onClick,
  type: "button",
  css: styles.linkButton
}, "View all"), ___EmotionJSX(ChevronRightIcon, {
  css: styles.linkIcon
})));
AllhomesViewSoldLink.propTypes = {
  titleText: PropTypes.string.isRequired,
  detailText: PropTypes.string,
  onClick: PropTypes.func
};
AllhomesViewSoldLink.defaultProps = {
  detailText: '',
  onClick: () => {}
};
export default AllhomesViewSoldLink;